<template>
  <p class="cmp-h-m">クレジットカード会社</p>
  <dl class="cmp-list">
    <dd class="col-md-9">
      <ul class="list-unstyled list-logo">
        <li>
          <img src="@/assets/img/logo_visa.jpg" alt="VISA" />
        </li>
        <li>
          <img src="@/assets/img/logo_mc.jpg" alt="MasterCard" />
        </li>
        <li class="logo-ae">
          <img src="@/assets/img/logo_ae.jpg" alt="American Express" />
        </li>
        <li>
          <img src="@/assets/img/logo_jcb.jpg" alt="JCB" />
        </li>
        <li>
          <img src="@/assets/img/logo_dci.jpg" alt="Diners Club Card" />
        </li>
      </ul>
    </dd>
  </dl>
</template>

<script>
export default {
  name: "List",
};
</script>
